import React from 'react'
import APPLE_ICON from '../../pngs/Apple.png'

export const AppleIcon = () => {
  return <img src={APPLE_ICON} width={24} height={24} />
}
